import * as React from 'react';
import { useTypedSelector } from '../../../../../hooks';
import { StopType } from '../../../../../types';
import { showDutchAddresLayout } from '../../../ducks';
import { AddressFieldsDutch } from './AddressFieldsDutch';
import { AddressFieldsOther } from './AddressFieldsOther';
export interface AddressFieldsProps {
  forceShowErrors: boolean;
  type: StopType;
  setLoading(isLoading: boolean): void;
  setIsFormError(isLoading: boolean): void;
}

export const AddressFields: React.FC<AddressFieldsProps> = props => {
  const isDutchLayout = useTypedSelector(showDutchAddresLayout);

  if (isDutchLayout) {
    return <AddressFieldsDutch {...props} />;
  }
  return <AddressFieldsOther {...props} />;
};
